import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  timeout: 10000,
});

// Her isteğe JWT token ekle
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 401 hatasında oturumu kapat — sadece auth dışı endpointlerde
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const isAuthEndpoint = err.config?.url?.includes('/auth/');
    if (err.response?.status === 401 && !isAuthEndpoint) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
  verifyEmail: (token) => api.get('/auth/verify-email?token=' + token),
  resendVerification: (email) => api.post('/auth/resend-verification', { email }),
  refresh: (refreshToken) => api.post('/auth/refresh', { refreshToken }),
  logout: (refreshToken) => api.post('/auth/logout', { refreshToken }),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (data) => api.post('/auth/reset-password', data),
};

// Öğrenci
export const studentAPI = {
  getProfile: () => api.get('/students/profile'),
  updateProfile: (data) => api.put('/students/profile', data),
  uploadCV: (file, lang = 'tr') => {
    const form = new FormData();
    form.append('cv', file);
    return api.post('/students/cv?lang=' + lang, form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  getMatches: () => api.get('/students/matches'),
  respondInvitation: (id, action) => api.post('/applications/' + id + '/respond', { action }),
};

// Şirket
export const companyAPI = {
  getProfile: () => api.get('/companies/profile'),
  updateProfile: (data) => api.put('/companies/profile', data),
  uploadLogo: (file) => { const f = new FormData(); f.append('logo', file); return api.post('/companies/logo', f, { headers: { 'Content-Type': 'multipart/form-data' } }); },
  deleteLogo: () => api.delete('/companies/logo'),
  getPositions: () => api.get('/companies/positions'),
  deletePosition: (id, force = false) => api.delete(`/companies/positions/${id}${force ? '?force=true' : ''}`),
  updatePosition: (id, data) => api.put(`/companies/positions/${id}`, data),
  createPosition: (data) => api.post('/companies/positions', data),
  updatePosition: (id, data) => api.put(`/companies/positions/${id}`, data),
  // Yeni: öğrenci havuzu + davet
  getStudents: (params) => api.get("/companies/students", { params }),
  getStudentDetail: (id) => api.get(`/companies/students/${id}`),
  inviteStudent: (data) => api.post("/companies/invite-student", data),
};

// Eşleştirme
export const matchAPI = {
  runMatching: (positionId) => api.post(`/matches/run/${positionId}`),
  getCandidates: (positionId, params) => api.get(`/matches/position/${positionId}`, { params }),
  updateStatus: (applicationId, status, extra = {}) => api.patch(`/matches/${applicationId}/status`, { status, ...extra }),
  bulkUpdateStatus: (applicationIds, status) => api.patch('/matches/bulk-status', { applicationIds, status }),
};

// Admin
export const adminAPI = {
  getStats: () => api.get('/admin/stats'),
  getCompanies: (params) => api.get('/admin/companies', { params }),
  approveCompany: (id) => api.patch(`/admin/companies/${id}/approve`),
  getStudents: (params) => api.get('/admin/students', { params }),
  getAuditLogs: (params) => api.get('/admin/audit-logs', { params }),
  getSystemHealth: () => api.get('/admin/system-health'),
  exportStudents: () => api.get('/admin/export/students', { responseType: 'blob' }),
  getStatsTrends: () => api.get('/admin/stats/trends'),
  getAppStats: () => api.get('/admin/stats/applications'),
  getAnalytics: () => api.get('/admin/analytics'),
  getSuggestedStudents: (companyId) => api.get(`/admin/companies/${companyId}/suggested-students`),
};

export default api;

// Ek admin metodları (Companies sayfası için)
export const extendedAdminAPI = {
  getCompanyDetail: (id) => api.get(`/admin/companies/${id}`),
  rejectCompany: (id, reason) => api.patch(`/admin/companies/${id}/reject`, { reason }),
  bulkApproveCompanies: (ids) => api.post('/admin/companies/bulk-approve', { ids }),
  deleteCompanyLogo: (id) => api.delete(`/admin/companies/${id}/logo`),
  messageCompanies: (company_ids, subject, message) => api.post('/admin/message-companies', { company_ids, subject, message }),

  getPositions: () => api.get('/admin/positions'),
  assignStudent: (data) => api.post('/admin/assign-student', data),
  getAssignedStudents: () => api.get('/admin/assigned-students'),
  exportAssignedStudents: () => api.get('/admin/assigned-students/export.xlsx', { responseType: 'blob' }),
  getAdmins: () => api.get('/admin/admins'),
  addAdmin: (data) => api.post('/admin/admins', data),
  deleteAdmin: (id) => api.delete('/admin/admins/' + id),
  toggleAdminActive: (id) => api.patch('/admin/admins/' + id + '/toggle-active'),
};
